module.exports = __webpack_public_path__ + "img/Sigil_of_the_Dead.95eb63cc.png";